export enum Permission {
  ReadAccount= "READ_ACCOUNT",
  ReadProfile= "READ_PROFILE",
  ManageAccount = 'MANAGE_ACCOUNT',
  MainAccount = 'MAIN_ACCOUNT'
}